import * as Yup from 'yup'

/** Reject Seller Market Product Order Item schema */
const sellerMarketProductOrderItemUpdateCourierFormSchema = Yup.object().shape({
  courier         : Yup.string().required('Required'),
  tracking_number : Yup.string().required('Required')
})

export default sellerMarketProductOrderItemUpdateCourierFormSchema
